import { ZusBalanceRowModel } from './zusData.model';

/**
 * Average balance of the pension subaccounts (second pillar)
 * by birth year and gender.
 *
 * Source: ZUS, Department of Statistics and Actuarial Forecasting,
 * https://www.zus.pl/pl/praca-i-emerytura/emerytura/wynagrodzenie-i-emerytura/kwoty-emerytury
 *
 */

// TODO: Read the data from a file (?)
export const ZUS_SUBACCOUNT_BALANCES: ZusBalanceRowModel[] = [
  { birthYear: 1949, female: 10181.43, male: 12761.91 },
  { birthYear: 1950, female: 11360.35, male: 9113.89 },
  { birthYear: 1951, female: 8438.44, male: 2935.57 },
  { birthYear: 1952, female: 12436.5, male: 3399.8 },
  { birthYear: 1953, female: 15012.4, male: 4059.8 },
  { birthYear: 1954, female: 14774.19, male: 4844.67 },
  { birthYear: 1955, female: 5559.34, male: 4226.75 },
  { birthYear: 1956, female: 6170.36, male: 5374.78 },
  { birthYear: 1957, female: 7233.97, male: 6901.88 },
  { birthYear: 1958, female: 9433.66, male: 11507.48 },
  { birthYear: 1959, female: 13902.74, male: 21414.23 },
  { birthYear: 1960, female: 23261.36, male: 44831.84 },
  { birthYear: 1961, female: 73477.55, male: 95678.22 },
  { birthYear: 1962, female: 88329.67, male: 100782.28 },
  { birthYear: 1963, female: 97053.04, male: 99948.87 },
  { birthYear: 1964, female: 105225.74, male: 98297.72 },
  { birthYear: 1965, female: 111178.91, male: 96143.68 },
  { birthYear: 1966, female: 112031.25, male: 94821.34 },
  { birthYear: 1967, female: 108332.29, male: 92199.68 },
  { birthYear: 1968, female: 105828.87, male: 89725.79 },
  { birthYear: 1969, female: 78898.58, male: 64889.77 },
  { birthYear: 1970, female: 76389.6, male: 62418.88 },
  { birthYear: 1971, female: 73362.58, male: 59660.48 },
  { birthYear: 1972, female: 70056.12, male: 59849.62 },
  { birthYear: 1973, female: 67688.91, male: 59871.81 },
  { birthYear: 1974, female: 64291.36, male: 59348.41 },
  { birthYear: 1975, female: 60938.93, male: 58588.24 },
  { birthYear: 1976, female: 57247.97, male: 58039.77 },
  { birthYear: 1977, female: 54969.8, male: 56235.4 },
  { birthYear: 1978, female: 52829.8, male: 54054.31 },
  { birthYear: 1979, female: 50747.23, male: 52418.4 },
  { birthYear: 1980, female: 48272.42, male: 50196.63 },
  { birthYear: 1981, female: 46089.0, male: 47982.93 },
  { birthYear: 1982, female: 44318.14, male: 46203.45 },
  { birthYear: 1983, female: 42556.39, male: 44484.55 },
  { birthYear: 1984, female: 40749.23, male: 42568.05 },
  { birthYear: 1985, female: 38834.86, male: 40705.87 },
  { birthYear: 1986, female: 36959.65, male: 38247.47 },
  { birthYear: 1987, female: 34940.1, male: 36282.88 },
  { birthYear: 1988, female: 33470.41, male: 34738.57 },
  { birthYear: 1989, female: 32293.49, male: 33613.7 },
  { birthYear: 1990, female: 31257.82, male: 32630.89 },
  { birthYear: 1991, female: 29750.45, male: 30649.34 },
  { birthYear: 1992, female: 27792.76, male: 28247.41 },
  { birthYear: 1993, female: 25833.08, male: 26124.78 },
  { birthYear: 1994, female: 23896.0, male: 24134.23 },
  { birthYear: 1995, female: 21668.8, male: 21795.7 },
  { birthYear: 1996, female: 19305.75, male: 19687.23 },
  { birthYear: 1997, female: 16818.08, male: 17587.84 },
  { birthYear: 1998, female: 14304.35, male: 15200.2 },
  { birthYear: 1999, female: 11575.11, male: 12779.86 },
  { birthYear: 2000, female: 5185.85, male: 6036.16 },
];
